import React, { } from 'react';

import { Routes, Route  } from "react-router-dom";

import { Home } from "../pages/Home/Home.jsx";
import { Contato } from "../pages/Contato/Contato.jsx";
import { Cotacao } from "../pages/Cotacao/Cotacao.jsx";
import { FAQ } from "../pages/FAQ/FAQ.jsx";
import { Politica } from "../pages/Politica/Politica.jsx";
import { Sobre } from "../pages/Sobre/Sobre.jsx";


export function AppRoutes(){


    return(
        <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/contato" element={<Contato/>} />
            <Route path="/cotacao" element={<Cotacao/>} />
            <Route path="/faq" element={<FAQ/>} />
            <Route path="/politica" element={<Politica/>} />
            <Route path="/sobre" element={<Sobre/>} />
        </Routes>
    );

}